<template>
  <div>
    <SlideItemSkeleton />
    <ul class="mt-2 flex animate-pulse items-center justify-center gap-4">
      <li v-for="item in 4" :key="item">
        <div class="size-3 rounded-full bg-secondary" />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { SlideItemSkeleton } from '@/5_entities/Slide'
</script>
